import React, { Component } from 'react'

class CheckBox extends Component {
  constructor(props) {
    super(props)
  }

  onChange = e => {
    this.setState({
      checked: e.target.checked
    })

    this.props.onTickChanged(e.target.checked, e.target.value)
  }

  render() {    
    return (
      <div className="custom-checkbox">
          <input
            type = 'checkbox'
            name = {this.props.Name}            
            id = {this.props.id}
            checked = {this.props.Checked}
            onChange = {this.onChange}
            value = {this.props.Value}                
          />
          <label htmlFor={this.props.id} className = {this.props.Checked ? "ticked": "unticked"}>
            <span>{this.props.text}</span>
          </label>
      </div>
    )
  }
}

export default CheckBox
